import React, { useState } from "react";
import "./product-details.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

import { ProductStatus } from "../../../../../../modules/products/types/status";
import ProductDocumentsComponent from "../product-documents/product-documents.component";
import UpdateProductStatusModal from "../../../../modals/update-product-status/update-product-status.modal";
import ProductFormComponent from "../product-form/product-form.component";
import { ResponsablePersonComponent } from "../../../../../../components/responsable-person/responsable-person.component";

interface ProductDetailsComponentProps {
  loading: boolean;
  product: any;
  onUpdate: () => void;
}
const ProductDetailsComponent = (props: ProductDetailsComponentProps) => {
  const { t } = useTranslation();
  const { loading, product, onUpdate } = props;

  const [
    showUpdateProductStatusModal,
    setShowUpdateProductStatusModal,
  ] = useState(false);

  return (
    <Box className="product__details">
      <Box className="title mb-4">
        {loading ? (
          <Skeleton variant="text" height={20} width={350} />
        ) : (
          <Typography
            variant="h2"
            color="textPrimary"
            className="text-capitalize"
          >
            {t("PRODUCTS_PAGE.AI_SOFTWARE_PRODUCT_DETAILS")}
          </Typography>
        )}
        {loading ? (
          <Skeleton variant="text" height={18} width={200} />
        ) : (
          <Typography
            variant="subtitle1"
            color="textSecondary"
            className="text-capitalize"
          >
            {t("PRODUCTS_PAGE.ORGANIZE_THE_INFORMATIONS")}
          </Typography>
        )}
      </Box>
      <Box className="product__details__content">
        {/* Product details form */}
        <ProductFormComponent
          loading={loading}
          product={product}
          onUpdate={onUpdate}
        />
        <Box>
          <Box className="mb-4">
            <ResponsablePersonComponent
              user={product.responsible}
              loading={loading}
              editable={true}
              title={t("RESPONSIBLE_PERSON")}
            />
          </Box>
          {/* Product status */}
          <Box className="status__container mb-4">
            {loading ? (
              <Skeleton variant="text" height={90} width="100%" />
            ) : (
              <Box
                className="global__box__content p-3  d-flex align-items-center justify-content-between"
                style={{ background: ProductStatus[product.status].bgColor }}
              >
                <Box className="d-flex flex-column">
                  <Typography
                    variant="h2"
                    className="text-capitalize"
                    style={{
                      color: ProductStatus[product.status].color,
                    }}
                  >
                    {t(ProductStatus[product.status].name)}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{ color: ProductStatus[product.status].color }}
                  >
                    {t("STATUS")}
                  </Typography>
                </Box>
                <Typography
                  variant="subtitle2"
                  className="edit__status"
                  style={{ color: ProductStatus[product.status].color }}
                  onClick={() => setShowUpdateProductStatusModal(true)}
                >
                  {t("EDIT")}
                </Typography>
                {showUpdateProductStatusModal && (
                  <UpdateProductStatusModal
                    show={showUpdateProductStatusModal}
                    onClose={(value: boolean) => {
                      setShowUpdateProductStatusModal(false);
                      if (value) {
                        onUpdate();
                      }
                    }}
                    status={product.status}
                    productId={product.id}
                  />
                )}
              </Box>
            )}
          </Box>
          {/* Product Documents */}
          <Box className="product__documents mb-4">
            <ProductDocumentsComponent
              productId={product.id}
              files={product.files}
              loading={loading}
              onDelete={() => {}}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductDetailsComponent;
